// extracted by mini-css-extract-plugin
module.exports = {"canvasHidden":"style_canvasHidden__21LiD","container":"style_container__1yUJU","content":"style_content__2Yr7C","textContent":"style_textContent__2S60o"};